import { usePermissionApi } from "../api/PermissionApiClient";
import { PermissionFrontendService } from "../services/PermissionFrontendService";

export const usePermissionService = (): PermissionFrontendService =>
  new PermissionFrontendService(usePermissionApi());
